<div class="flex-container" ngDefaultControl>
  <div style="flex: 6">
    <div class="column">
      <app-text-input
        [label]="'First Name'"
        [required]="true"
        [(ngModel)]="this.data.firstName"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>
    <div class="column">
      <app-text-input
        [label]="'Last Name'"
        [required]="true"
        [(ngModel)]="this.data.lastName"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>
    <div class="column">
      <app-text-input
        [label]="'Email Address'"
        [type]="inputTextModes.Email"
        [required]="false"
        [(ngModel)]="this.data.emailAddress"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>
    <div class="column">
      <app-text-input
        [label]="'Phone'"
        [required]="false"
        [type]="inputTextModes.Phone"
        [(ngModel)]="this.data.phone"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>

    @if (this.enableEditing) {
      <div>
        @if (this.mode == FormMode.Edit) {
          <input
            class="button_primary button_var_2"
            type="button"
            value="Save"
            style="width: 200px; margin-left: 15px"
            (click)="btnSave_click()"
            (keydown.enter)="btnSave_click()"
          />
        }
        @if (this.mode == FormMode.Edit) {
          <input
            class="button_primary button_var_2"
            type="button"
            value="Cancel"
            style="width: 200px; margin-left: 15px"
            (click)="btnCancel_click()"
            (keydown.escape)="btnCancel_click()"
          />
        }
      </div>
    }
  </div>

  <div style="flex: 1; text-align: right" [hidden]="!this.enableEditing">
    <div
      style="
        float: right;
        background-color: #f7f7f7;
        padding: 3px;
        width: 25px;
        height: 25px;
        cursor: pointer;
      "
      title="Edit"
      [hidden]="this.mode == FormMode.Edit"
      (click)="btnEdit_click()"
    >
      <i class="fa-regular fa-pen-to-square icon"></i>
    </div>
    <div style="clear: both"></div>
  </div>
</div>
